import React from "react";
import PropTypes from "prop-types";
import { Modal2, ModalConfirm, ProgressBar, Flex, KPICard } from "@evertrue/et-components";
import VolunteerContactCard from "./volunteer-contact-card";
import { useVolunteerSessionResolver } from "../contexts/volunteer-session-context";
import StageReport from "./stage-report";
import numeral from "numeral";
import { round } from "../utils/utils";
import VolunteerStatsModalActivity from "./volunteer-stats-modal-activity";
import { usePoolDataResolver } from "../contexts/pool-data-resolver";

const VolunteerStatsModal = ({
  volunteerAnalyticsData = {},
  onClose,
  pool = {},
  stagesForGroup,
  hasStagesFeature,
  orgFiscalYearEnd,
  isHeadAgentEnabled,
  ...rest
}) => {
  const dollars_raised_percentage = round(
    (volunteerAnalyticsData.total_dollars_raised / pool.total_dollars_raised) * 100
  );
  const { session = {}, loading: session_loading } = useVolunteerSessionResolver(
    volunteerAnalyticsData.solicitor_contact_id
  );
  const { activityDateParameters } = usePoolDataResolver(pool.id, orgFiscalYearEnd);

  return (
    <Modal2
      contentStyle={{ width: "80vw", minWidth: "unset", maxWidth: "1000px" }}
      isOpen={Boolean(volunteerAnalyticsData.solicitor_contact_id)}
      onClose={onClose}
    >
      <ModalConfirm hasMargin closeModal={onClose} header="Volunteer Insights">
        <div className="volunteer-stats-modal">
          <Flex justifyContent="space-between">
            <VolunteerContactCard
              isHeadAgentEnabled={isHeadAgentEnabled}
              solicitor_contact_id={volunteerAnalyticsData.solicitor_contact_id}
              pool={pool}
              className="volunteer-stats-modal--contact-card"
              {...volunteerAnalyticsData}
              {...rest}
            />
            <KPICard width="auto" disableBorderRight title="Assigned" value={volunteerAnalyticsData.assignment_count} />
            <KPICard width="auto" title="% Participation" value={round(volunteerAnalyticsData.participation)} />

            <Flex
              justifyContent="space-around"
              className="volunteer-stats-modal--dollars-section"
              alignItems="baseline"
            >
              {pool.giving_category_label !== "EverTrueNoData" ? (
                <>
                  <KPICard
                    className="volunteer-stats-modal--raised-card"
                    title="$ Raised"
                    value={numeral(volunteerAnalyticsData.total_dollars_raised).format("0,.[00]")}
                    disableBorderRight
                    width="auto"
                  />
                  <div className="volunteer-stats-modal--dollars-raised-section">
                    <span className="volunteer-stats-modal--dollars-raised-label"> % Dollars Raised in Pool</span>
                    <ProgressBar
                      width="auto"
                      className="pool-report--progress-bar"
                      backgroundColor={"#fff"}
                      percent={dollars_raised_percentage}
                    />
                    {dollars_raised_percentage} %
                  </div>
                </>
              ) : (
                <KPICard title="No Giving Data" width="auto" />
              )}
            </Flex>
          </Flex>
          <Flex>
            {!session_loading && (
              <KPICard width="auto" title="Activity" className="volunteer-stats-modal--activity-card">
                <VolunteerStatsModalActivity
                  poolId={pool.id}
                  volunteerAnalyticsData={volunteerAnalyticsData}
                  userId={session.user_id}
                  activityDateParameters={activityDateParameters}
                />
              </KPICard>
            )}
            <KPICard width="auto" title="Stages" className="volunteer-stats-modal--stage-card">
              <StageReport
                prospectsTotal={volunteerAnalyticsData.assignment_count}
                hasStagesFeature={hasStagesFeature}
                stagesForGroup={stagesForGroup}
                poolId={pool.id}
                solicitorContactId={volunteerAnalyticsData.solicitor_contact_id}
              />
            </KPICard>
          </Flex>
        </div>
      </ModalConfirm>
    </Modal2>
  );
};

VolunteerStatsModal.propTypes = {
  volunteerAnalyticsData: PropTypes.object,
  orgFiscalYear: PropTypes.string,
  onClose: PropTypes.func,
  pool: PropTypes.object,
  hasStagesFeature: PropTypes.bool,
  isHeadAgentEnabled: PropTypes.bool,
};

export default VolunteerStatsModal;
